import * as Illustration from "@npco/zeller-design-system/illustration";

import { ListSteps } from "../../shared/list-steps";
import { PromptBig } from "../../shared/prompt-big";

/** Shared with the hosts's error, so both read the same. */
export const NETWORK_ERROR_MESSAGE =
	"Please ensure this device is connected to the internet.";

export function NetworkErrorPrompt() {
	return (
		<PromptBig
			image={<Illustration.ErrorBoatSinking loop={false} />}
			title="Unable to connect to Zeller"
			message={
				<>
					{NETWORK_ERROR_MESSAGE}
					<ListSteps
						items={[
							"Confirm your device is connected to your network.",
							"Check if the network is connected to the internet.",
						]}
					/>
				</>
			}
		/>
	);
}
